var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnePerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F8F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 18V16.6667C17.3337 15.9594 17.0527 15.2811 16.5526 14.781C16.0525 14.281 15.3742 14 14.667 14H9.33366C8.62641 14 7.94814 14.281 7.44804 14.781C6.94794 15.2811 6.66699 15.9594 6.66699 16.6667V18M14.667 8.66667C14.667 10.1394 13.4731 11.3333 12.0003 11.3333C10.5276 11.3333 9.33366 10.1394 9.33366 8.66667C9.33366 7.19391 10.5276 6 12.0003 6C13.4731 6 14.667 7.19391 14.667 8.66667Z",
    stroke: "#5E639B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnePerson);
export default __webpack_public_path__ + "static/media/OnePerson.cf762b9679118f3c6ec1692b7f97fc0f.svg";
export { ForwardRef as ReactComponent };